import React from 'react';
import { CTABand } from '../../components/CTABand';
export function KidsKarateFinalCTA() {
  return <CTABand headline="Ready to Try Storm Taekwondo?" copy="Storm teaches Taekwondo, not karate — but the values are the same. Talk to Storm about the best starting class for your child." data-id="element-2042" />;
}